import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonAvatarModule } from '../person-avatar/person-avatar.module';
import { PipesModule } from '../pipes/pipes.module';
import { ManageIdentitiesModule } from '../manage-identities/manage-identities.module';
import { HealthPackageConfirmRequestComponent } from '../health-package-confirm-request/health-package-confirm-request.component';
import { HealthPackageDetailsModule } from '../health-package-details/health-package-details.module';
import { PaymentCheckoutModule } from '../payment-checkout/payment-checkout.module';
import { ApptDtlCardModule } from '../appt-dtl-card/appt-dtl-card.module';
import { AltpaymentInputModule } from '../components/altpayment-input/altpayment-input.module';
import { PromoInputModule } from '../components/promo-input/promo-input.module';
import { CouponModalModule } from '../coupon-modal/coupon-modal.module';
import { CouponModule } from '../coupon/coupon.module';
import { DisplayCurrencyModule } from '../components/display-currency/display-currency.module';
import { FormsModule } from '@angular/forms';
import { ServiceIncludedModule } from '../service-included/service-included.module';
import { AlternatePaymentModule } from '../components/alternate-payment/alternate-payment.module';
@NgModule({
  declarations: [HealthPackageConfirmRequestComponent],
  imports: [
    CommonModule,
    PersonAvatarModule, 
    FormsModule,
    PipesModule,
    ManageIdentitiesModule,
    HealthPackageDetailsModule,
    PaymentCheckoutModule,
    ApptDtlCardModule,
    CouponModule,
    CouponModalModule,
    PromoInputModule, AltpaymentInputModule, DisplayCurrencyModule, AlternatePaymentModule
  ],
  exports: [
    HealthPackageConfirmRequestComponent
  ]
})
export class HealthPackageConfirmRequestModule { }
